import { AddFeatureButton } from 'pages/siteView/siteMap/popupMenus/editMode/plusMenu/AddFeatureButton'
import { EditSiteConfigButton } from 'pages/siteView/siteMap/popupMenus/editMode/plusMenu/EditSiteConfigButton'
import React, { Dispatch, FC, SetStateAction } from 'react'
import styled from 'styled-components'

const MenuContainer = styled.div<{ $isOpen: boolean }>`
  display: flex;
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  flex-direction: column;
  align-items: end;
  gap: 8px;
  margin: 20px 10px;
  height: ${({ $isOpen }) => ($isOpen ? '80px' : '70px')};
  transition: height 200ms;
`

interface MapPlusMenuProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

export const MapPlusMenu: FC<MapPlusMenuProps> = (props) => {
  return (
    <MenuContainer $isOpen={props.isOpen}>
      <EditSiteConfigButton closeMenu={() => props.setIsOpen(false)} />
      <AddFeatureButton closeMenu={() => props.setIsOpen(false)} />
    </MenuContainer>
  )
}
